import {
    DXP_GET_SYMPOSIUM_UPLOAD,
    DXP_GET_SYMPOSIUM_UPLOAD_ERROR,
    DXP_COUNT_SYMPOSIUM_UPLOAD,
    DXP_COUNT_SYMPOSIUM_UPLOAD_ERROR,
    DXP_MODIFY_SYMPOSIUM_UPLOAD,
    DXP_MODIFY_SYMPOSIUM_UPLOAD_ERROR,
    DXP_SELECT_SYMPOSIUM_UPLOAD,
} from "../actions/types";


const initialState = {
    symposiumUploads: [],
    selectedSymposiumUpload: null,
    count: 0,
    isLoading: true,
    success: false,
};


export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case DXP_GET_SYMPOSIUM_UPLOAD:
            return {
                ...state,
                symposiumUploads: payload,
                isLoading: false,
                success: true,
            };
        case DXP_COUNT_SYMPOSIUM_UPLOAD:
            return {
                ...state,
                count: payload,
                isLoading: false,
                success: true,
            };
        case DXP_SELECT_SYMPOSIUM_UPLOAD:
            return {
                ...state,
                selectedSymposiumUpload: payload,
            };
        case DXP_MODIFY_SYMPOSIUM_UPLOAD:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        case DXP_GET_SYMPOSIUM_UPLOAD_ERROR:
            return {
                ...state,
                symposiumUploads: [],
                isLoading: false,
                success: true,
            };
        case DXP_COUNT_SYMPOSIUM_UPLOAD_ERROR:
            return {
                ...state,
                count: 0,
                isLoading: false,
                success: true,
            };
        case DXP_MODIFY_SYMPOSIUM_UPLOAD_ERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}